import * as Sentry from '@sentry/browser'

import * as h2Api from '../h2Api'

export const FETCH_MANAGEMENT_STATUS = 'FETCH_MANAGEMENT_STATUS'
export const EDIT_PROFILE_FORM_FIELD_CHANGE = 'EDIT_PROFILE_FORM_FIELD_CHANGE'
export const EDIT_PROFILE_CLICK_TAB = 'EDIT_PROFILE_CLICK_TAB'
export const EDIT_PROFILE_SAVE = 'EDIT_PROFILE_SAVE'
export const TOGGLE_MODAL = 'TOGGLE_MODAL'
export const EDIT_MANAGEMENT_MODAL_CHANGE = 'EDIT_MANAGEMENT_MODAL_CHANGE'
export const LOOKUP_MANAGER_ID = 'LOOKUP_MANAGER_ID'
export const MANAGEMENT_REMOVE_REQUEST = 'MANAGEMENT_REMOVE_REQUEST'
export const MANAGEMENT_REMOVE_RELATION = 'MANAGEMENT_REMOVE_RELATION'
export const REQUEST_MANAGER_CONFIRM = 'REQUEST_MANAGER_CONFIRM'
export const REQUEST_MGMT_BY_CODE = 'REQUEST_MGMT_BY_CODE'

export const changeManagementRequestField = fieldValue => dispatch => {
  return dispatch({ type: EDIT_MANAGEMENT_MODAL_CHANGE, fieldValue })
}

export const lookupManagementUser = () => (dispatch, getState) => {
  const teacherId = getState().editPersonalProfile.management.managementRequest.fields
    .teacherId

  return dispatch(
    h2Api.post('/management/finduser', { user: teacherId })({ type: LOOKUP_MANAGER_ID })
  )
}

export const confirmManagementUser = () => (dispatch, getState) => {
  const mgmtState = getState().editPersonalProfile.management

  if (mgmtState.modalParams.id === 1) {
    const teacherId = mgmtState.managementRequest.fields.teacherId

    return dispatch(requestManagementFromCode(teacherId))
  }

  console.log('Management by non-educators is not implemented')
}

export const requestManagementFromCode = code => dispatch => {
  if (!code || code.trim().toLowerCase() == 'null') {
    Sentry.withScope(scope => {
      scope.setExtras(`received ${code} in request to associate with manager`)
      Sentry.captureException(
        new Error(`received ${code} in request to associate with manager`)
      )
    })
  }

  return dispatch(
    h2Api.post(
      `/management/request/association/${code}`,
      {}
    )({ type: REQUEST_MGMT_BY_CODE })
  )
}

export const deleteManager = managerId => dispatch => {
  // console.log(managerId)
  return dispatch(
    h2Api.doDelete(`/user/managers/${managerId}`)({ type: MANAGEMENT_REMOVE_REQUEST })
  ).then(v => {
    dispatch({ type: MANAGEMENT_REMOVE_RELATION, managerId })

    return v
  })
}

export const changeFormField = fieldValue => dispatch => {
  return dispatch({ type: EDIT_PROFILE_FORM_FIELD_CHANGE, fieldValue })
}

export const fetchManagementStatus = () =>
  h2Api.get('/user/managers')({ type: FETCH_MANAGEMENT_STATUS })

export const clickTab = tabId => dispatch => {
  dispatch({ type: EDIT_PROFILE_CLICK_TAB, tabId })

  if (tabId === 'management') {
    dispatch(fetchManagementStatus())
  }
}
